import { render, staticRenderFns } from "./KitchenChargeDetailDialog.vue?vue&type=template&id=fca3eda2&scoped=true"
import script from "./KitchenChargeDetailDialog.vue?vue&type=script&lang=js"
export * from "./KitchenChargeDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./KitchenChargeDetailDialog.vue?vue&type=style&index=0&id=fca3eda2&prod&scoped=true&lang=css"
import style1 from "./KitchenChargeDetailDialog.vue?vue&type=style&index=1&id=fca3eda2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca3eda2",
  null
  
)

export default component.exports